import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  CompareWithDirective,
  ControlErrorDirective,
  InputClearButtonDirective,
  RequiredDirective,
} from 'eurogard-material-form-system';
import {
  DataGridCellDefDirective,
  DataGridComponent,
  DataGridEditCellDefDirective,
  DataGridRowDefDirective,
} from 'eurogard-data-grid';
import { FormDirective } from 'eurogard-forms';
import { InputSelectOptionsDirective } from 'eurogard-form-system';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { StopPropagationDirective } from '@rxap/directives';
import {
  UserInfoDataSource,
} from 'angular-components/layout/default-header/user-profile-icon/user-settings/user-info.data-source';
import { MatDialog } from '@angular/material/dialog';
import {
  SetUserPasswordDialogComponent,
} from 'angular-components/set-user-password-dialog/set-user-password-dialog.component';
import {
  UserSettingsAccordionDataSource,
} from 'angular-components/layout/default-header/user-profile-icon/user-settings/user-settings-accordion.data-source';
import { FormBuilderProviders, FormProviders } from './form.providers';

@Component({
  selector: 'eurogard-user-account-information',
  imports: [
    CompareWithDirective,
    ControlErrorDirective,
    DataGridCellDefDirective,
    DataGridComponent,
    DataGridEditCellDefDirective,
    DataGridRowDefDirective,
    FormDirective,
    InputClearButtonDirective,
    InputSelectOptionsDirective,
    MatButton,
    MatError,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    MatSuffix,
    ReactiveFormsModule,
    RequiredDirective,
    StopPropagationDirective,
  ],
  providers: [
    UserInfoDataSource,
    FormProviders,
    FormBuilderProviders
  ],
  templateUrl: './user-account-information.component.html',
  styleUrl: './user-account-information.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAccountInformationComponent {
  protected readonly userInfoDataSource = inject(UserInfoDataSource);
  public readonly accordionDataSource = inject(UserSettingsAccordionDataSource);
  private readonly dialog = inject(MatDialog);

  public openResetPasswordDialog() {
    this.dialog.open(SetUserPasswordDialogComponent, {
      data: { __rowId: this.accordionDataSource.user()?.uuid },
    });
  }
}
